import FilePrintedVersion from '@/modules/FileDetail/components/documentation/FilePrintedVersion.tsx';
import HealthCertificate from '@/modules/FileDetail/components/documentation/HealthCertificate.tsx';
import FileImagesZip from '@/modules/FileDetail/components/documentation/FileImagesZip.tsx';
import FileDocumentZip from '@/modules/FileDetail/components/documentation/FileDocumentZip.tsx';
import {
  DocumentationGeneratorType,
  DocumentationType,
} from '@/modules/FileDetail/components/documentation/DocumentationGenerator.type.ts';

const DocumentationGenerator = ({ types }: DocumentationGeneratorType) => {
  const documentsType = {
    file_printed_version: <FilePrintedVersion />,
    health_certificate: <HealthCertificate />,
    file_images_zip: <FileImagesZip />,
    file_document_zip: <FileDocumentZip />,
  };

  const components = Object.keys(documentsType).filter((item) =>
    types.includes(item as DocumentationType),
  );

  return (
    <>
      {components.map((key) => (
        <div key={key}>{documentsType[key as DocumentationType]}</div>
      ))}
    </>
  );
};

export default DocumentationGenerator;
